export const SORT_BY = [
  {
    label: __('Recently active'),
    value: 'new',
  },
  {
    label: s__('Forum|Most Popular'),
    value: 'popular',
  },
] as const;

export const MOST_POPULAR = 'popularity';
export const NEWEST = 'updated_at';

export const SORT_BY_FOR_API = {
  new: {
    sort_by: NEWEST,
  },
  popular: {
    sort_by: MOST_POPULAR,
  },
} as const;

export const CLASS_NAME = 'Forums::Discussion';

export const QUERY_KEYS = {
  categories: 'forum-categories',
  discussion: 'forum-discussion',
  editDiscussion: 'forum-edit-discussion',
} as const;

export const TRANSLATION_TYPE = 'forums_discussion';

export const COMMENTS_SCROLL = 'comments';

export const CATEGORY_URL_PARAM = 'cat';
